import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import {
  ResetPasswordRequest,
  ResetPasswordResponse,
  SendResetPasswordEmailRequest,
  ValidateTokenResponse,
} from './merchant-identity.types';

export const validateToken = async (host: string, limepayToken: string): Promise<ValidateTokenResponse> =>
  fetch(`${host}/authn/validate-token`, await getFetchOptions('POST', { limepayToken })).then(handleResponse);

export const sendResetPasswordEmail = async (host: string, payload: SendResetPasswordEmailRequest): Promise<void> =>
  fetch(`${host}/authn/send-reset-password-email`, await getFetchOptions('POST', { payload })).then(handleResponse);

export const resetPassword = async (
  host: string,
  limepayToken: string,
  payload: ResetPasswordRequest,
): Promise<ResetPasswordResponse> =>
  fetch(`${host}/authn/reset-password`, await getFetchOptions('POST', { payload, limepayToken })).then(handleResponse);
